// Per-VeerGi alerts: 10 tones low→high, gesture-unlocked audio, vibration where supported.
let ctx = null;
let unlocked = false;

export const TONES = [
  { id: 1, name: "Soft Chime", freqs: [523], beeps: 1, type: "sine", gain: 0.06 },
  { id: 2, name: "Gentle Bell", freqs: [659], beeps: 1, type: "sine", gain: 0.09 },
  { id: 3, name: "Two-Note", freqs: [523, 659], beeps: 2, type: "sine", gain: 0.11 },
  { id: 4, name: "Warm Triad", freqs: [523, 659, 784], beeps: 3, type: "sine", gain: 0.12 },
  { id: 5, name: "Front Desk", freqs: [880, 660], beeps: 2, type: "triangle", gain: 0.14 },
  { id: 6, name: "Kitchen Bump", freqs: [660, 880, 1100], beeps: 3, type: "square", gain: 0.14 },
  { id: 7, name: "Double Ring", freqs: [988, 988, 1175, 1175], beeps: 4, type: "triangle", gain: 0.16 },
  { id: 8, name: "Sharp Ping", freqs: [1319, 1319, 1319], beeps: 3, type: "square", gain: 0.18 },
  { id: 9, name: "Rush Hour", freqs: [1100, 1319, 1100, 1319, 1568], beeps: 5, type: "square", gain: 0.2 },
  { id: 10, name: "Full Friday", freqs: [1319, 1568, 1319, 1568, 1319, 1760], beeps: 6, type: "square", gain: 0.24 },
];

const getCtx = () => {
  const Ctx = window.AudioContext || window.webkitAudioContext;
  if (!Ctx) return null;
  if (!ctx) ctx = new Ctx();
  return ctx;
};

// Must be called from a user gesture (sign-in tap / START SHIFT). Returns true if audio works.
export const unlockAudio = async () => {
  const c = getCtx();
  if (!c) return false;
  try {
    if (c.state === "suspended") await c.resume();
    unlocked = c.state === "running";
    return unlocked;
  } catch {
    return false;
  }
};

export const audioUnlocked = () => unlocked && ctx && ctx.state === "running";

export const playTone = (id) => {
  const t = TONES.find((x) => x.id === id) || TONES[2];
  const c = getCtx();
  if (!c) return false;
  if (c.state === "suspended") c.resume().catch(() => {});
  try {
    t.freqs.forEach((f, i) => {
      const at = i * 0.22;
      const o = c.createOscillator();
      const g = c.createGain();
      o.type = t.type;
      o.frequency.value = f;
      o.connect(g);
      g.connect(c.destination);
      g.gain.setValueAtTime(0.0001, c.currentTime + at);
      g.gain.exponentialRampToValueAtTime(t.gain, c.currentTime + at + 0.02);
      g.gain.exponentialRampToValueAtTime(0.0001, c.currentTime + at + 0.34);
      o.start(c.currentTime + at);
      o.stop(c.currentTime + at + 0.4);
    });
    return true;
  } catch {
    return false;
  }
};

// Vibration API: supported on Android Chrome/Firefox; NOT supported in Safari on iPhone/iPad.
export const canVibrate = () => typeof navigator !== "undefined" && "vibrate" in navigator;
export const doVibrate = () => { try { navigator.vibrate && navigator.vibrate([220, 110, 220]); } catch { /* no-op */ } };

// Quiet hours: "23:00"–"10:00" wraps midnight; uses the device's local clock.
export const inQuietHours = (start, end) => {
  if (!start || !end) return false;
  const now = new Date();
  const mins = now.getHours() * 60 + now.getMinutes();
  const [sh, sm] = start.split(":").map(Number);
  const [eh, em] = end.split(":").map(Number);
  const s = sh * 60 + sm, e = eh * 60 + em;
  return s <= e ? mins >= s && mins < e : mins >= s || mins < e;
};
